module.exports = __webpack_public_path__ + "img/abmes-02.44433d0e.png";